import { CreatorAction } from "@/types/types";
import {
  Frame,
  FrameHeader,
  FramePanel,
  FrameTitle,
} from "@/components/ui/frame";
import EmailThread from "../EmailThread";

interface EmailThreadFrameProps {
  action: CreatorAction;
  emailThread: any[];
  threadLoading: boolean;
}

export default function EmailThreadFrame({
  action,
  emailThread,
  threadLoading,
}: EmailThreadFrameProps) {
  return (
    <Frame className="w-full">
      <FrameHeader>
        <FrameTitle>Email Thread</FrameTitle>
      </FrameHeader>
      <FramePanel className="w-full flex flex-col gap-2 p-0">
        <EmailThread
          emailThread={emailThread}
          selectedAction={action}
          threadLoading={threadLoading}
        />
      </FramePanel>
    </Frame>
  );
}
